import { memo } from 'react';
import { AB3, S3 } from '../../../theme';
import TextField from '../DefaultTextField';
import { TTextFieldProps } from '../index';
import { mergeSX } from '../../../services/helpers';
import InputAdornment from '../../InputAdornment';
import { CalendarIcon } from '../../../icons';
import { TYPOGRAPHY_BODY1 } from '../../Typography';
import CaretIcon from '../../../icons/CaretIcon';

interface IBuildSXParams {
  open?: boolean;
}

const buildSX = ({ open }: IBuildSXParams) => ({
  '& .MuiOutlinedInput-root': {
    paddingRight: 0.5,
    cursor: 'pointer',
    borderRadius: 4,
    '&.MuiInputAdornment-root': {
      paddingRight: 0,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '2px solid',
      borderColor: open ? AB3 : S3,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: open ? AB3 : S3,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: open ? AB3 : S3,
    },
  },
  '& .MuiInputBase-input': {
    '&.MuiOutlinedInput-input': {
      padding: '12px 12px 12px 0',
      ...TYPOGRAPHY_BODY1,
      WebkitTextFillColor: AB3,
      minWidth: 210,
      cursor: 'pointer',
    },
  },
  '& .MuiInputAdornment-positionEnd': {
    color: AB3,
    cursor: 'pointer',
    marginRight: 2,
    transform: open ? 'rotate(180deg)' : '',
  },
});

export type TDateSelectTextFieldProps = TTextFieldProps & {
  open: boolean;
}

const DateSelectTextField = (props: TDateSelectTextFieldProps) => {
  const { sx, open = false, ...restProps } = props;

  return (
    <TextField
      sx={mergeSX(buildSX({ open }), sx)}
      InputProps={{
        startAdornment:
  <InputAdornment position="start"><CalendarIcon color={AB3} /></InputAdornment>,
        endAdornment:
  <InputAdornment position="end"><CaretIcon width={18} height={18} /></InputAdornment>,
        readOnly: true,
      }}
      {...restProps}
    />
  );
};

export default memo(DateSelectTextField);
